var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ro-status-tag",style:({
        color: _vm.meta.color,
        backgroundColor: _vm.meta.bg,
        borderColor: _vm.meta.color ? `${_vm.meta.color}40` : 'transparent',
    })},[_c('span',{staticClass:"ro-status-dot",style:({ backgroundColor: _vm.meta.color })}),_c('span',{staticClass:"ro-status-text"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }